import type { ReactNode } from "react";
import "./ScheduleTemplateCell.scss";
import { scopeForTemplate } from "@/pages/human-resources/time-management/components/schedule-palette/bottom-row/legend/EntityScope.ts";
import type { ScheduleTemplate } from "@/pages/human-resources/time-management/business/schedule-template/ScheduleTemplate.ts";
import type { TemplateTimeSlot } from "@/pages/human-resources/time-management/business/time-slot/TemplateTimeSlot.ts";
import classNames from "classnames";
import { Color } from "@/shared/utils/ColorUtils.ts";

interface Properties {
  template: ScheduleTemplate;
  isDuplicate: boolean;
  selected?: boolean;
  onClick: () => void;
}

export default function ScheduleTemplateCell(props: Properties): ReactNode {
  const entityScope =
    props.isDuplicate ? scopeForTemplate(props.template) : undefined;
  return (
    <div
      className={classNames(
        "schedule-template-cell",
        props.selected === true && "selected",
        isDarkBackground() && "light-color",
      )}
      style={{ backgroundColor: props.template.color }}
      onPointerDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
        props.onClick();
      }}
    >
      <div className="label">{props.template.label}</div>
      {props.template.timeSlots.map((ts) => (
        <div
          key={ts.startTime.toString()}
          className={classNames(
            "time-slot",
            ts.category === undefined && "no-category",
          )}
        >
          {formatTimeSlot(ts)}
        </div>
      ))}
      {entityScope !== undefined && (
        <div className={`corner-icon ${entityScope}`} />
      )}
    </div>
  );

  function formatTimeSlot(ts: TemplateTimeSlot): string {
    const times = `${ts.startTime.formatTime()} - ${ts.endTime.formatTime()}`;
    return ts.category === "BREAK" ? `(${times})` : times;
  }

  function isDarkBackground(): boolean {
    return (
      props.template.color !== undefined &&
      Color.fromHexaValue(props.template.color).luminance() < 0.4
    );
  }
}
